<div cdkVirtualScrollingElement class="content">
  <iu-storekeeper-transfer-details class="details" />
  @if (isConvertingToCond()) {
    <iu-storekeeper-window-pallet-panel />
  } @else if (selectedLine()) {
    <iu-storekeeper-transfer-line-details />
  } @else {
    <iu-storekeeper-transfer-lines (validateTransfer)="save()" />
  }
</div>

@if (!isComplete() && !selectedLine() && !isConvertingToCond()) {
  @if (!state.pending() && isLinesComplete()) {
    <iu-storekeeper-navbar-button
      [icon]="'icon-circle-check'"
      [label]="'ConfirmTransfer' | SKWTranslate"
      [type]="'confirm'"
      (onClick)="save($event)" />
  } @else if (!isNewTransfer() || hasLines()) {
    <iu-storekeeper-navbar class="navbar" [canExpand]="false">
      <iu-storekeeper-navbar-button
        [active]="tabActive() === 'TL'"
        [count]="lines()?.TL?.length"
        [hideCount]="!state.loaded() || lines()?.TL?.length === 0"
        [icon]="'icon-dolly'"
        [label]="'ToLoad' | SKWTranslate"
        (onClick)="changeActiveTab($event, 'TL')" />
      <iu-storekeeper-navbar-button
        [active]="tabActive() === 'UL'"
        [count]="isConditioning() ? 1 : lines()?.UL?.length"
        [hideCount]="!state.loaded() || lines()?.UL?.length === 0"
        [icon]="'icon-truck-ramp-box'"
        [label]="'ToUnload' | SKWTranslate"
        (onClick)="changeActiveTab($event, 'UL')" />
    </iu-storekeeper-navbar>
  }
}
